<template>
  <div>
    <el-row>
      <el-col style="width: 350px" align="left">
        <div class="option-label" style="margin-left: 10px; padding-bottom: 5px; padding-top: 10px">Show</div>
        <el-radio-group v-model="plotOrganism" size="small" style="margin-left: 10px">
          <el-tooltip class="item" content="Plot data for the current organism" effect="dark" placement="top" :enterable="false">
            <el-radio-button label="current">Current Organism</el-radio-button>
          </el-tooltip>
          <el-tooltip class="item" content="Compare data for all selected organisms" effect="dark" placement="top" :enterable="false">
            <el-radio-button label="all">All selected Organisms</el-radio-button>
          </el-tooltip>
        </el-radio-group>
      </el-col>

      <el-col style="width: 250px" align="left">
        <div class="option-label" style="padding-bottom: 5px; padding-top: 10px">Select repeats</div>
        <el-select v-model="plotOptions.selected" collapse-tags multiple filterable
          placeholder="Select repeats" style="width: 90%" size="small">
          <el-option-group v-for="group in repeatsMultiSelectOptions" :key="group.label" :label="group.label">
            <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-option-group>
        </el-select>
      </el-col>
      <el-col style="width: 150px" align="left">
        <el-checkbox v-model="plotOptions.allRepeats" size="small" style="padding: 10px; height: 100%; margin-left: 10px; margin-top: 25px">All Repeats</el-checkbox>
      </el-col>
      <el-col v-if="plotOrganism === 'all'" style="width: 250px" align="left">
          <div class="option-label" style="padding-bottom: 5px; padding-top: 10px">Group by </div>
          <el-switch style="display: block" v-model="plotOptions.groupByRepeat" inactive-color="#13ce66"
            active-color="#13ce66" active-text="Repeat" inactive-text="Organism"></el-switch>
        </el-col>

    </el-row>

    <el-row v-if="plotOrganism === 'current'" style="margin-top: 20px">
      <modal-unit-stack-anno-distribution height="70vh" :series="stackDistributionData[store.species.order.indexOf(store.species.current)]"></modal-unit-stack-anno-distribution>
    </el-row>

    <el-row :gutter="15" v-if="plotOrganism === 'all'">
      <el-row v-if="!(plotOptions.groupByRepeat)">
        <el-col :lg="8" :md="12" :sm="12" :xs="24" v-for="(organism, index) in store.info" :key="organism.OrgInfo.MSDBID"
          style="margin-top: 30px">
          <modal-unit-stack-anno-distribution :index="index+1" :series="stackDistributionData[index]"></modal-unit-stack-anno-distribution>
        </el-col>
      </el-row>

      <el-row :gutter="15" v-if="plotOptions.groupByRepeat" >
        <el-col :lg="8" :md="12" :sm="12" :xs="24" v-for="(repeat, index) in plotOptions.selected" :key="repeat"
          style="margin-top: 30px">
          <modal-unit-stack-anno-distribution :index="index+1" :series="stackDistributionData[index]"></modal-unit-stack-anno-distribution>
        </el-col>
      </el-row>
    </el-row>
  </div>
</template>

<script>
  import { store } from '../scripts/store.js'
  import ModalUnitStackAnnoDistribution from '../components/ModalUnitStackAnnoDistribution.vue'
  import { repeatsMultiSelectOptions } from '../scripts/repeatsMultiSelectOptions.js'
  import { repeatAnnoDist } from '../scripts/utils.js'
  import { repeats } from '../scripts/repeats.js'


  export default {
    name: 'ModalStackAnnoDistribution',
    components: {
      ModalUnitStackAnnoDistribution
    },
    data() {
      return {
        store: store,
        plotOrganism: "current",
        repeatsMultiSelectOptions: repeatsMultiSelectOptions,
        plotOptions: {
          selected: ["A", "C", "AC", "AG", "AT", "CG"],
          groupByRepeat: false,
          allRepeats: false
        }
      }
    },
    computed: {
      stackDistributionData: function(){
        let parameters = this.plotOptions;
        const repeats = parameters.selected;
        const organisms = this.store.species.order;
        let organismNames = [];
        const info = this.store.info;

       const annoKeys = ['Exon', 'Intron', 'Genic', 'Intergenic']
        const promKeys = ['Promoter', 'Non-Promoter'];

        let series = [];
        for (let o of organisms) {
          const data = [];
          const orginfo = info.filter(a => { return a.OrgInfo.MSDBID === o; })[0];
          let organismName = orginfo.OrgInfo.OrganismName;
          if (orginfo.OrgInfo.Annotation === 'Y'){
            if (!(parameters.allRepeats)) {
              const plotdata = orginfo.AnnoInfo.RepAnno;
              organismNames.push(organismName);
              const genomeSize = parseInt(orginfo.GenomeInfo.GenomeSize);
              const annodata = repeatAnnoDist(plotdata, repeats);
              annoKeys.forEach( a => {
                const d = repeats.map(r => {
                  const repindex = Object.keys(plotdata).indexOf(r);
                  if (repindex > -1){ return annodata[r][a] }
                  else {return 0}
                });
                 data.push({ name: a, type: 'bar', barWidth: '30%', stack: 'Annotation', data: d }) 
              })  
              promKeys.forEach(p => {
                const d = repeats.map(r => {
                  const repindex = Object.keys(plotdata).indexOf(r);
                  if (repindex > -1){ return annodata[r][p] }
                  else {return 0}
                });
                data.push({ name: p, type: 'bar', barWidth: '30%', stack: 'Promoter', data: d }) 
              })
              if (organismName.length > 25) { organismName = organismName.slice(0, 25) + '...' }
    
              series.push({
                title: organismName, 
                data: data, 
                yAxis: { 
                  name: 'Percentage',
                  nameLocation: 'middle',
                  nameGap: 30,
                  margin: 8, 
                  nameTextStyle: {
                    fontSize: 14,
                    fontWeight: 'bold'
                  },
                  type: 'value', 
                  min: 0, 
                  max: 100, 
                }, 
                xAxis: {
                  name: 'Repeat Class',
                  nameLocation: 'middle',
                  nameGap: 25,
                  margin: 8, 
                  nameTextStyle: {
                    fontSize: 14,
                    fontWeight: 'bold'
                  },
                  type: 'category', 
                  data: repeats,
                  alignWithLael: true
                }
              });
            }
            else {
              const plotdata = orginfo.AnnoInfo.RepAnno;
              const annoKeyObj = {'Exon': ['EP', 'EN'], 'Intron': ['IP', 'IN'], 'Genic': ['GP', 'GN'], 'Intergenic': ['DP', 'DN']}
              const promKeyObj ={ 'Promoter': ['EP', 'IP', 'GP', 'DP'], 'Non-Promoter': ['EN', 'IN', 'GN', 'DN'] };

              const annoKeys = Object.keys(annoKeyObj);
              const promKeys = Object.keys(promKeyObj);

              const data = []
              let annodata = repeatAnnoDist(plotdata, 'all')
              annoKeys.forEach(a => {
                if (annodata[a]!= 0){
                  data.push({ name: a, type: 'bar', barWidth: '40%', stack: 'Annotation', data: [annodata[a]] })
                }
              })

              promKeys.forEach(p => {
                if (annodata[p] != 0){
                  data.push({ name: p, type: 'bar', barWidth: '40%', stack: 'Promoter', data: [annodata[p]] })
                }
              })

              const xAxis = {
                type: 'value', min: 0, max: 100,
                name: 'Percentage',
                nameLocation: 'middle',
                nameGap: 30,
                margin: 8,
                nameTextStyle: {
                  fontSize: 14,
                  fontWeight: 'bold'
                },
              }
              series.push({
                title: organismName,
                data: data,
                xAxis: xAxis,
                yAxis: { type: 'category', data: ['All repeats'], axisLabel: { rotate: 90 } } })
            }
          }
        }

        if ((parameters.groupByRepeat) && (this.plotOrganism === "all")) {
          const tempseries = [];
          repeats.forEach( (r, i) => {
            const obj = {
              title: r, 
              yAxis: { 
                name: 'Percentage',
                nameLocation: 'middle',
                nameGap: 30,
                margin: 8, 
                nameTextStyle: {
                  fontSize: 14,
                  fontWeight: 'bold'
                },
                type: 'value', 
                min: 0, 
                max: 100, 
              }, 
              xAxis: { 
                nameGap: 10,
                type: 'category', 
                data: organismNames,
                alignWithLabel: true,
                axisLabel: { rotate: 40 }
              }
            };
            const data = [];
            annoKeys.forEach(a => {
              const dataobj = {name: a, type: 'bar', barWidth: '30%', stack: 'Annotation'};
              const values = [];
              const d = organisms.forEach( (o, j) => { 
                const adata = series[j].data.filter(d => { return d.name === a; });
                if(adata.length > 0){
                  
                  values.push(adata[0].data[i])
                }
              })
              if (values.length > 0){
                dataobj.data = values;
                data.push(dataobj);
              }
            })

            promKeys.forEach(a => {
              const dataobj = {name: a, type: 'bar', barWidth: '30%', stack: 'Promoter'};
              const values = [];
              const d = organisms.forEach( (o, j) => { 
                const adata = series[j].data.filter(d => { return d.name === a; });
                if(adata.length > 0){
                  values.push(adata[0].data[i])
                }
              })
              dataobj.data = values;
              data.push(dataobj)
            })
            obj.data = data;
            tempseries.push(obj)
          })
          
          series = tempseries;
        }

        return series;
      }

    }
  }
</script>